<template>
  <div class="home">
    <div class="boxContainer">
      <div class="titleContainer">
        <div class="title">
          <img src="../assets/logo.png" alt="" srcset="" /><span
            >中国能建统一系统入口</span
          >
        </div>
        <div class="directionsContainer">
          <div class="wang" @click="jump('https://app.ceec.net.cn')">
            <img class="circle_img" src="../assets/china.png" alt="" />
            <span class="circle_title">一张网入口</span>
          </div>
          <div></div>
          <div class="internet" @click="jump('https://vpn1.ceec.net.cn')">
            <img class="circle_img" src="../assets/世界地图.png" alt="" />
            <span class="circle_title">互联网入口</span>
          </div>
        </div>
      </div>
      <div class="notice">
        <div class="notice_left">
          <div class="noticeTitle">公告</div>
          <div class="noticeText">
            <p>
              本网站服务于能建统建系统用户，在一张网内访问请通过<strong style="color: rgb(31, 92, 156)">一张网入口</strong
              >登录，互联网访问请通过<strong style="color: rgb(31, 92, 156)">互联网入口</strong
              >登录。
            </p>
          </div>
        </div>
        <el-divider direction="vertical"></el-divider>
        <div class="notice_right">
          <div class="notice_rightTitle">常用操作及链接</div>
          <ul>
            <li>
              <span>e能建管理端登录及客户端下载：</span
              ><a
                href="https://e.ceec.net.cn"
                target="_blank"
                title="https://e.ceec.net.cn"
                rel="noopener noreferrer"
                >https://e.ceec.net.cn</a
              >
            </li>
            <li>
              <span>外网门户地址：</span
              ><a
                href="https://e.ceec.net.cn"
                target="_blank"
                title="https://e.ceec.net.cn"
                rel="noopener noreferrer"
                >http://www.ceec.net.cn/index.html</a
              >
            </li>
            <li>
              <!-- <span>IT反馈通道操作手册：</span> -->
              <a
                href="javascript:;"
                rel="noopener noreferrer"
                title="附件1.IT反馈通道用户操作手册.pdf"
                @click="showPdf('附件1.IT反馈通道用户操作手册')"
                >IT反馈通道用户操作手册</a
              >
            </li>
            <li>
              <!-- <span>微盘和微文档使用指南：</span> -->
              <a
                href="javascript:;"
                rel="noopener noreferrer"
                title="VPN操作说明"
                @click="showPdf('VPN操作说明')"
                >VPN操作说明</a
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
export default {
  name: 'Home',
  components: {
  },
  data() {
    return {
      ifPdf: false,
      pdfUrl: ''
    }
  },
  created() {

  },
  methods: {
    jump(url) {
      window.open(url, "_blank");
    },
    showPdf(url) {
      window.open('/static/pdf/'+url+'.pdf')
    }
  }
}
</script>
<style scoped>
.home {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background-image: url("../assets/login_mainbg.jpg");
  background-size: cover;
  background-attachment: fixed;
  background-position: center center;
}
.boxContainer {
  position: absolute;
  width: 100%;
  height: 100%;
}
.titleContainer {
  width: 70%;
  height: 33%;
  margin: 5% auto 0;
}
.title,
.noticeTitle {
  font-weight: bold;
  color: #101111;
}
.title {
  font-size: 46px;
  display: inline-block;
  border-radius: 10px;
  width: 100%;
  margin-bottom: 5%;
}
.title img {
  display: inline-block;
  vertical-align: bottom;
  width: 11%;
}
.title span {
  padding: 0 15px;
}
.directionsContainer {
  height: 48%;
  position: relative;
}
.directionsContainer div {
  position: absolute;
  background: rgba(255, 255, 255, 0.6);
  border-radius: 5px;
  cursor: pointer;
  padding: 0 10px;
  box-shadow: -5px -2px 10px 2px rgb(1 113 185 / 20%);
  border: 1px solid #dcdfe6;
  transition: 0.3s;
}
.circle {
  position: absolute;
  top: 20%;
  left: 24%;
  width: 250px;
}
.circle_title {
  width: 260px;
  text-align: center;
  color: #101111;
  font-size: 40px;
  height: 110px;
  line-height: 110px;
  display: inline-block;
}
.circle_img {
  width: 80px;
  height:80px;
  display: inline-block;
  vertical-align: bottom;
  margin: 15px 0 15px 10px
}
.wang:hover {
  background: rgba(31, 92, 156, 0.5);
  border: 1px solid #4e9bcf;
}
.wang:hover span {
  color: #e7f1fa;
}
.internet {
  right: 21.5%;
}
.internet:hover {
  background: rgba(31, 92, 156, 0.5);
  border: 1px solid #4e9bcf;
}
.internet:hover span {
  color: #e7f1fa;
}
.notice_left {
  width: 30%;
  height: 100%;
  position: absolute;
  left: 15%;
}
.notice_right {
  width: 30%;
  height: 100%;
  position: absolute;
  left: 50.5%;
}
.notice {
  width: 100%;
  height: 45%;
  background: rgba(255, 255, 255, 0.8);
  position: relative;
}
.noticeTitle {
  height: 20%;
  line-height: 3;
  font-size: 32px;
}
.notice_rightTitle {
  height: 20%;
  line-height: 3;
  font-size: 32px;
  font-weight: bold;
}
.noticeText {
  height: 80%;
  text-align: center;
}
.noticeText p {
  font-size: 20px;
  text-align: left;
  text-indent: 40px;
  line-height: 40px;
  letter-spacing: 5px;
}
.notice_right ul {
  height: 80%;
}
.notice_right ul li {
  height: 40px;
  line-height: 40px;
  text-align: left;
  color: #101111;
  font-size: 20px;
  width: 85%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.notice_right ul li a {
  color: rgb(31, 92, 156);
  text-decoration: none;
}
.notice_right ul li a:hover {
  color: rgba(31, 92, 156,0.6);
  text-decoration: underline;
}
.el-divider--vertical {
  display: inline-block;
  width: 1px;
  height: 80%;
  margin: 48px 8px;
  vertical-align: middle;
  position: absolute;
  left: 47%;
}
.el-divider {
  background-color: #e7f1fa;
}
</style>
